<template>
  <TablePaginated
      label="Popular Places"
      sublabel="What attractions do your passengers view the most?"
      :main-list="itemData"
      :is-global-percent="isGlobalPercent"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TablePaginated from '../../../TablePaginated.vue';

export default {
  name: 'PagedListPopularPlacesNative',
  components: {
    TablePaginated,
  },

  props: {
    itemData: {
      type: [Array],
      default() {
        return ([]);
      },
    },
  },

  methods: {
    ...mapActions({
      setActiveDestination: 'metrics/setActiveDestination',
    }),
  },

  computed: {
    ...mapGetters({
      isGlobalPercent: 'metrics/isGlobalPercent',
    }),
  },
};
</script>
